function filterObjectByKeys(object, keys, blacklisted = true) {
    return Object.keys(object).reduce((accumulator, k) => {
        let returnValue = accumulator;

        if ((blacklisted && !keys.includes(k)) || (!blacklisted && keys.includes(k))) {
            returnValue = {
                ...accumulator,
                [k]: object[k],
            };
        }

        return returnValue;
    }, {});
}

function getLanguage() {
    return document.documentElement.lang.toLowerCase().indexOf("en") > -1 ? "en" : "fr";
}

export { filterObjectByKeys, getLanguage };
